module.exports = __webpack_public_path__ + "static/media/so-icon--beak.0b87eaf6.svg";